import React from 'react';
import styled from 'styled-components';

import PageIndicator from './PageIndicator';
import PrevPageButton from './PrevPageButton.js';
import NextPageButton from './NextPageButton.js';
import SendButton from './SendButton.js';

const pac = require('../../../package.json');

const Wrapper = styled.div`
  align-self: flex-end;
  height: 220px;
  width: 100%;
`;
const ButtonWrapper = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
`;

const PrevWrapper = styled.div`
  margin-left: 40px;
  opacity: ${props => (props.hide ? '0.4' : '1')};
`;

const NextWrapper = styled.div`
  margin-right: 80px;
`;

const VersionWrapper = styled.div`
  display: flex;
  flex-direction: row-reverse;
`;

const VersionTextWrapper = styled.div`
  font-size: 10px;
  margin-right: 30px;
`;

const WizardPageSelector = ({
  onPrev,
  onNext,
  pageNumber,
  pageCount,
  loading,
}) => (
  <Wrapper>
    <ButtonWrapper>
      <PrevWrapper hide={pageNumber === 1}>
        <PrevPageButton id="wizard-prev" type="button" onClick={onPrev} />
      </PrevWrapper>
      <NextWrapper>
        {pageNumber < pageCount ? (
          <NextPageButton id="wizard-next" type="button" onClick={onNext} />
        ) : (
          <SendButton
            id="wizard-send"
            type="button"
            onClick={onNext}
            loading={loading}
          />
        )}
      </NextWrapper>
    </ButtonWrapper>
    <PageIndicator current={pageNumber} total={pageCount} />
    <VersionWrapper>
      {' '}
      <VersionTextWrapper>
        {' '}
        Version {pac.version || null}
      </VersionTextWrapper>{' '}
    </VersionWrapper>
  </Wrapper>
);

export default WizardPageSelector;
